import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import MsalAuthWrapper from "./auth/MsalAuthWrapper";
import { setupMsalAxiosInterceptor } from "./auth/msalAxiosInterceptor";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";
import "./fonts/ford.scss";
import "./fonts/lincoln.scss";
import "./index.scss";
import { StyledEngineProvider } from "@mui/material/styles";
import { getMsalInstance } from "./auth/msalClient";

const msalInstance = getMsalInstance();

if (msalInstance) {
  setupMsalAxiosInterceptor();
}

if (!msalInstance) {
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      "MSAL is not configured. Set window.EMP.MSAL_CLIENT_ID and window.EMP.MSAL_TENANT_ID (or env equivalents) to enable authentication."
    );
  }
}

const AppWithCallbackAfterRender = () => {
  if (!msalInstance) {
    const empKeys = window.EMP ? Object.keys(window.EMP) : [];
    console.error(
      "MSAL not initialized. window.EMP =",
      window.EMP,
      "(keys:",
      empKeys,
      "). Expected MSAL_CLIENT_ID and MSAL_TENANT_ID; the loaded /config.js is likely stale."
    );
    return (
      <div style={{ padding: 20, textAlign: "center" }}>
        <p>
          Authentication configuration is missing. Please configure MSAL/Entra
          ID settings.
        </p>
        <pre style={{ textAlign: "left", display: "inline-block" }}>
          {JSON.stringify({ hasEMP: !!window.EMP, empKeys }, null, 2)}
        </pre>
      </div>
    );
  }

  return (
    <StyledEngineProvider injectFirst>
      <I18nextProvider i18n={i18n} defaultNS="emp">
        <MsalProvider instance={msalInstance}>
          <MsalAuthWrapper />
        </MsalProvider>
      </I18nextProvider>
    </StyledEngineProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppWithCallbackAfterRender />);
